import { patchUserService, sendSuccessService } from '@http/profileService'
import { deleteUserService } from '@http/profileService'
import { trackingService } from '@http/trackingService'
import { User } from '@types'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import {
  getPersonalTracking,
  getTrackingSuccess,
  getTeamTrackingSuccess,
  getTrackingFailed,
  patchStages,
  patchUser,
  selectAllSavers,
  deleteUserFailed,
  patchUserAction,
  patchStagesAction,
  patchFiles,
  patchFilesAction,
  deleteFile,
  deleteFilesAction,
  deleteUserProfileAction,
  deleteUserProfile,
  sendSuccess,
  deleteUserSuccess,
  getExecutives,
  getExecutivesSuccess,
  getTeamTracking,
  getExecutiveCases,
  postNewConversation,
  postNewConversationAction,
  postNewConversationSuccess,
  postNewConversationFailed,
  postNewConversationAndRefresh,
  getComplianceAction,
  recoverRejectedCase,
  recoverRejectedCaseAction
} from './trackingSlice2'
import { PayloadAction } from '@reduxjs/toolkit'
import { getExecutiveCasesService, getExecutivesService } from '@http/executivesService'
import { postNewConversationService } from '@http/conversationService'
import { userProfile } from '@views/profile/state/profileSlice'
import { Role } from '@types'
import { getAllSavers } from '@http/trackingService'
import { getCompliance } from '@http/complianceService'

const ALL_SAVERS_ROLES = [Role.admin, Role.gerente]

export function* trackingHttp() {
  const { cocap, userId } = yield select(selectCredentials)
  const { role } = yield select(userProfile)
  try {
    const users: User[] = yield call(trackingService, userId, cocap, 'personal')
    const teamUsers: User[] = ALL_SAVERS_ROLES.includes(role)
      ? yield call(getAllSavers, cocap)
      : yield call(trackingService, userId, cocap, 'team')
    yield put(getTrackingSuccess({ data: users, setSuccess: false }))
    yield put(getTeamTrackingSuccess(teamUsers))
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}

export function* teamTrackingSaga() {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const teamUsers: User[] = yield call(trackingService, userId, cocap, 'team')
    yield put(getTeamTrackingSuccess(teamUsers))
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}

export function* getExecutivesSaga() {
  const { cocap } = yield select(selectCredentials)
  try {
    const users: User[] = yield call(getExecutivesService, cocap)
    yield put(getExecutivesSuccess({ data: users, setSuccess: true }))
  } catch (e) {
    yield put(getExecutivesSuccess({ data: [], setSuccess: false }))
  }
}

export function* getExecutiveCasesSaga() {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const teamUsers: User[] = yield call(getExecutiveCasesService, cocap, userId)
    yield put(getTeamTrackingSuccess(teamUsers))
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}

export function* deleteUserHttp({ payload }: deleteUserProfileAction) {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    yield call(deleteUserService, payload.userId, cocap)
    if (payload.isTeam) {
      const teamUsers: User[] = yield call(trackingService, userId, cocap, 'team')
      yield put(getTeamTrackingSuccess(teamUsers))
    } else {
      const users: User[] = yield call(trackingService, userId, cocap, 'personal')
      yield put(getTrackingSuccess({ data: users, setSuccess: true }))
    }
  } catch (e) {
    yield put(deleteUserFailed(e.message))
  }
}

export function* patchUserStages({ payload }: patchStagesAction) {
  const { cocap, userId } = yield select(selectCredentials)
  const persons: User[] = yield select(selectAllSavers)
  const { userId: findUserId, stages, isRejected, isReturned, isTeam, successForm, extraFields } = payload
  try {
    const user = persons.find(person => person._id === findUserId)
    if (user) {
      const newUser = {
        ...user,
        isRejected,
        isReturned,
        ...successForm,
        extraFields,
        stages: { ...stages }
      }
      yield call(patchUserService, newUser, cocap)
      if (isTeam) {
        const teamUsers: User[] = yield call(trackingService, userId, cocap, 'team')
        yield put(getTeamTrackingSuccess(teamUsers))
      } else {
        const users: User[] = yield call(trackingService, userId, cocap, 'personal')
        yield put(getTrackingSuccess({ data: users, setSuccess: true }))
      }
    }
  } catch (e) {
    window.console.log(e)
    yield put(getTrackingFailed(e.message))
  }
}

export function* patchUserSaga({ payload }: patchUserAction) {
  const { cocap, userId } = yield select(selectCredentials)
  const persons: User[] = yield select(selectAllSavers)
  const { dataProfile, isTeam } = payload
  try {
    const user = persons.find(person => person._id === dataProfile._id)
    if (user) {
      yield call(patchUserService, dataProfile, cocap)
      if (isTeam) {
        const teamUsers: User[] = yield call(trackingService, userId, cocap, 'team')
        yield put(getTeamTrackingSuccess(teamUsers))
      } else {
        const users: User[] = yield call(trackingService, userId, cocap, 'personal')
        yield put(getTrackingSuccess({ data: users, setSuccess: true }))
      }
    }
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}
export function* patchUserFiles(action: patchFilesAction) {
  const { cocap, userId } = yield select(selectCredentials)
  const persons: User[] = yield select(selectAllSavers)
  const { files, userId: findUserId } = action.payload
  try {
    const user = persons.find(person => person._id === findUserId)
    if (user) {
      let newUser: User
      newUser = {
        ...user,
        files,
        stages: user.stages?.office
          ? user.stages
          : {
              studyDate: '',
              office: '',
              bank: '',
              success: '',
              feesOrPayments: '',
              delivered: ''
            }
      }
      yield call(patchUserService, newUser, cocap)
      const personalUsers: User[] = yield call(trackingService, userId, cocap, 'personal')
      const teamUsers: User[] = yield call(trackingService, userId, cocap, 'team')
      yield put(getTrackingSuccess({ data: personalUsers, setSuccess: false }))
      yield put(getTeamTrackingSuccess(teamUsers))
    }
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}

export function* deleteUserFile(action: deleteFilesAction) {
  const { cocap, userId } = yield select(selectCredentials)
  const persons: User[] = yield select(selectAllSavers)
  const { fileId, userId: findUserId } = action.payload
  try {
    const user = persons.find(person => person._id === findUserId)
    if (user) {
      const fileIndex = user.files.findIndex(doc => doc._id && fileId == doc._id)
      const files = [...user.files]
      files.splice(fileIndex, 1)
      const newUser = {
        ...user,
        files
      }
      yield call(patchUserService, newUser, cocap)
      const personalUsers: User[] = yield call(trackingService, userId, cocap, 'personal')
      const teamUsers: User[] = yield call(trackingService, userId, cocap, 'team')
      yield put(getTrackingSuccess({ data: personalUsers, setSuccess: false }))
      yield put(getTeamTrackingSuccess(teamUsers))
    } else console.error('error not user found', findUserId, persons)
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}

export function* sendSuccessSaga(action: PayloadAction<string>) {
  const { cocap } = yield select(selectCredentials)
  try {
    yield call(sendSuccessService, action.payload, cocap)
    yield put(deleteUserSuccess({}))
  } catch (e) {
    yield put(deleteUserFailed(e.message))
  }
}

export function* postNewConversationSaga(action: postNewConversationAction) {
  const { cocap } = yield select(selectCredentials)
  const { value, userId, type } = action.payload
  try {
    yield call(postNewConversationService, value, userId || '', type || 'observation', cocap)
    yield put(postNewConversationSuccess())
  } catch (e) {
    yield put(postNewConversationFailed(e.message))
  }
}

export function* postConversationAndRefreshSaga(action: postNewConversationAction) {
  try {
    yield call(postNewConversationSaga, action)
    yield call(trackingHttp)
  } catch (e) {
    yield put(postNewConversationFailed(e.message))
  }
}

export function* recoverRejectedCaseSaga(action: recoverRejectedCaseAction) {
  const { cocap, userId } = yield select(selectCredentials)
  const { userId: findUserId, isTeam, stages, recoveryMessage } = action.payload

  try {
    yield call(postNewConversationService, recoveryMessage, findUserId, 'recovery', cocap)
    yield call(
      patchUserService,
      {
        _id: findUserId,
        stages,
        isRejected: false,
        isRecovered: true,
        isReturned: false
      },
      cocap
    )

    if (isTeam) {
      const teamUsers: User[] = yield call(trackingService, userId, cocap, 'team')
      yield put(getTeamTrackingSuccess(teamUsers))
    } else {
      const users: User[] = yield call(trackingService, userId, cocap, 'personal')
      yield put(getTrackingSuccess({ data: users, setSuccess: true }))
    }
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}

export function* getComplianceSaga() {
  const { cocap } = yield select(selectCredentials)
  try {
    const teamUsers: User[] = yield call(getCompliance, cocap)
    yield put(getTeamTrackingSuccess(teamUsers))
  } catch (e) {
    yield put(getTrackingFailed(e.message))
  }
}

export default function* trackingSaga() {
  yield takeEvery(getPersonalTracking.type, trackingHttp)
  yield takeEvery(getTeamTracking.type, teamTrackingSaga)
  yield takeEvery(getExecutiveCases.type, getExecutiveCasesSaga)
  yield takeEvery(patchStages.type, patchUserStages)
  yield takeEvery(patchUser.type, patchUserSaga)
  yield takeEvery(patchFiles.type, patchUserFiles)
  yield takeEvery(deleteFile.type, deleteUserFile)
  yield takeEvery(deleteUserProfile.type, deleteUserHttp)
  yield takeEvery(sendSuccess.type, sendSuccessSaga)
  yield takeEvery(getExecutives.type, getExecutivesSaga)
  yield takeEvery(postNewConversation.type, postNewConversationSaga)
  yield takeEvery(postNewConversationAndRefresh.type, postConversationAndRefreshSaga)
  yield takeEvery(recoverRejectedCase.type, recoverRejectedCaseSaga)
  yield takeEvery(getComplianceAction.type, getComplianceSaga)
}
